/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsRevolutOpenBankingCallback204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsRevolutOpenBankingCallback505Schema = z.any();

export const optionsRevolutOpenBankingCallbackMutationResponseSchema = z.lazy(
  () => optionsRevolutOpenBankingCallback204Schema
);
